import { useQuery } from "@tanstack/react-query";
import { OfferService } from "@/generated/services/OfferService";
import { light_offer_extended } from "@/lib/models/light_offer_extended";
type OfferResponseWithHeaders = {
  total?: number;
  page?: number;
  per_page?: number;
  items?: light_offer_extended[];
  __headers?: Headers;
};
export function useFetchOffers(
  memberId: number,
  storeId?: number,
  holdersFetched?: boolean,
  shouldWaitForStores?: boolean,
  storesFetched?: boolean,
) {
  // Determine if we should enable the query
  // If we should wait for stores, only enable when stores are fetched
  // Otherwise, enable as soon as holders are fetched
  const isEnabled =
    !!memberId &&
    holdersFetched === true &&
    (!shouldWaitForStores || storesFetched === true);

  return useQuery({
    queryKey: ["offers", memberId, storeId],
    enabled: isEnabled,
    refetchOnMount: "always", // Refetch whenever the component mounts
    queryFn: async (): Promise<light_offer_extended[]> => {
      const response = (await OfferService.getOffers(
        memberId as number,
        undefined,
        undefined,
        undefined,
        storeId,
        Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
        undefined,
        1000,
        undefined,
      )) as OfferResponseWithHeaders;

      return (response.items || []) as light_offer_extended[];
    },
  });
}
